(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homepage-video-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('home-video-player')) {
    customElements.define('home-video-player', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.videoControlsReady === 'true') return;
        this.dataset.videoControlsReady = 'true';

        const video = this.querySelector('video');
        const playButton = this.querySelector('[data-home-video-play]');
        const audioButton = this.querySelector('[data-home-video-audio]');
        if (!video || !playButton || !audioButton) return;

        const controls = this.querySelector('[data-home-video-controls]');
        const playLabel = playButton.getAttribute('aria-label');
        const pauseLabel = controls.dataset.pauseLabel;
        const muteLabel = controls.dataset.muteLabel;
        const unmuteLabel = controls.dataset.unmuteLabel;

        video.controls = false;
        video.autoplay = false;
        video.loop = false;

        const showControls = () => this.setAttribute('data-controls-visible', '');
        const hideControls = () => this.removeAttribute('data-controls-visible');
        const syncPlayback = () => {
          const isPlaying = !video.paused && !video.ended;
          this.toggleAttribute('data-video-playing', isPlaying);
          playButton.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
          if (!isPlaying) showControls();
        };
        const syncAudio = () => {
          audioButton.setAttribute('aria-pressed', String(video.muted));
          audioButton.setAttribute('aria-label', video.muted ? unmuteLabel : muteLabel);
        };

        playButton.addEventListener('click', async (event) => {
          if (video.paused || video.ended) {
            try {
              await video.play();
              if (event.detail > 0) {
                playButton.blur();
                hideControls();
              }
            } catch {
              showControls();
            }
          } else {
            video.pause();
          }
        });

        audioButton.addEventListener('click', () => {
          video.muted = !video.muted;
          syncAudio();
        });

        video.addEventListener('click', showControls);
        video.addEventListener('play', () => {
          syncPlayback();
        });
        video.addEventListener('pause', syncPlayback);
        video.addEventListener('ended', syncPlayback);
        video.addEventListener('volumechange', syncAudio);
        this.addEventListener('focusout', () => {
          if (!video.paused) hideControls();
        });

        syncPlayback();
        syncAudio();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
